import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock } from "vue";
import PackageName from './modules/packageName.vue';
import { UseComProps } from './modules/hooks';
export default /*#__PURE__*/_defineComponent({
  props: UseComProps(),
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(PackageName, {
        gid: _ctx.gid,
        channel: _ctx.channel
      }, null, 8, ["gid", "channel"]);
    };
  }
});